import {getNewsIndex,getNewsArticleList} from '@/api'


const actions = {
	async getNewsList({commit}){
		let res = await getNewsIndex()
        if(!res.code){
		commit('SAVE_NEWS_INDEX',res.data)
        }else{
            alert(res.message)
        }
	},
    async getNewsNavArticleList({commit},{id,currentPage,pageSize}){
		let res = await getNewsArticleList({
            nav_id: id,
            page: currentPage,
            page_size: pageSize
        })
        if(!res.code){
		commit('SAVE_NEWS_NAV_ARTICLE_LIST',res.data)
        }else{
            alert(res.message)
        }
	},
    async getHotArticleList({commit},{id,currentPage,pageSize}){
		let res = await getNewsArticleList({
            nav_id: id,
            page: currentPage,
            page_size: pageSize
        })
        if(!res.code){
		commit('SAVE_HOT_ARTICLE_LIST',res.data)
        }else{
            alert(res.message)
        }
	},
    async getCooArticleList({commit},{id,currentPage,pageSize}){
		let res = await getNewsArticleList({
            nav_id: id,
            page: currentPage,
            page_size: pageSize
        })
        if(!res.code){
		commit('SAVE_COO_ARTICLE_LIST',res.data)
        }else{
            alert(res.message)
        }
	},
}

const mutations = {
	SAVE_NEWS_INDEX(state,data){
		state.newsIndexList = data
	},
    SAVE_NEWS_NAV_ARTICLE_LIST(state,data){
		state.newsNavArticleInfo = data
	},
    SAVE_HOT_ARTICLE_LIST(state,data){
		state.hotArticleList = data.data
	},
    SAVE_COO_ARTICLE_LIST(state,data){
		state.cooArticleList = data.data
	},
}

const state = {
    newsIndexList:[],
    newsNavArticleInfo:{},
    hotArticleList:[],
    cooArticleList:[],
}

const getters = {
	newsIndexListLeft(state){
        return state.newsIndexList.filter((item)=> item.id !=5 && item.id != 4)
    },
    hotNew(state){
        return state.newsIndexList.filter((item)=> item.id ==4)
    },
    cooperation(state){
        return state.newsIndexList.filter((item)=> item.id ==5)
    },
    cooArticleLeft(state){
        return state.cooArticleList.slice(0,4)
    }

}

export default {
	actions,
	mutations,
	state,
	getters
}